import React from "react";
import MainLayout from "../../layouts/MainLayout";
import BlogSection from "../../section/BlogSection";
const BlogPage = () => {
  return (
    <MainLayout>
      <BlogSection />
    </MainLayout>
  );
};

export default BlogPage;
